import { Resource } from "../resource";


export class Settings extends Resource {
    freeShippingMin : number
}